module.exports = __webpack_public_path__ + "static/media/goals.94297d50.svg";